import { useRequestUrl } from '../../../config';
import type { GlobalConfig } from '../../../types';
import { DEVELOPMENT_URLS, getTestingUrl, PRODUCTION_URLS } from './urls';

export const noaIntegrationConfigTransformer = <E>(config: E & GlobalConfig) => {
  const getConfigBaseUrl = useRequestUrl({
    productionUrls: PRODUCTION_URLS,
    developmentUrls: DEVELOPMENT_URLS,
    testingUrl: getTestingUrl,
  });

  const baseURL = getConfigBaseUrl(config) || '';

  return {
    ...config,
    baseURL,
  };
};
